export enum Tools {
	Selection,
	Point,
	Polygon,
	Line,
	Height,
	Circle,
	Annotation,
}

export function isCadTool(tool: Tools): boolean {
	return tool !== Tools.Selection;
}
